"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _EventType = _interopRequireDefault(require("./events/EventType.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * @module ol/MapBrowserEventType
 */

/**
 * Constants for event names.
 * @enum {string}
 */
var _default = {
  /**
   * A true single click with no dragging and no double click. Note that this
   * event is delayed by 250 ms to ensure that it is not a double click.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#singleclick
   * @api
   */
  SINGLECLICK: 'singleclick',

  /**
   * A click with no dragging. A double click will fire two of this.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#click
   * @api
   */
  CLICK: _EventType["default"].CLICK,

  /**
   * A true double click, with no dragging.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#dblclick
   * @api
   */
  DBLCLICK: _EventType["default"].DBLCLICK,

  /**
   * Triggered when a pointer is dragged.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#pointerdrag
   * @api
   */
  POINTERDRAG: 'pointerdrag',

  /**
   * Triggered when a pointer is moved. Note that on touch devices this is
   * triggered when the map is panned, so is not the same as mousemove.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#pointermove
   * @api
   */
  POINTERMOVE: 'pointermove',
  POINTERDOWN: 'pointerdown',
  POINTERUP: 'pointerup',
  POINTEROVER: 'pointerover',
  POINTEROUT: 'pointerout',
  POINTERENTER: 'pointerenter',
  POINTERLEAVE: 'pointerleave',
  POINTERCANCEL: 'pointercancel'
};
/***
 * @typedef {'singleclick'|'click'|'dblclick'|'pointerdrag'|'pointermove'} Types
 */

exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUdBOzs7O0FBSEE7Ozs7QUFLQTs7OztlQUllO0VBQ2I7Ozs7OztFQU1BQSxXQUFXLEVBQUUsYUFQQTs7RUFTYjs7Ozs7RUFLQUMsS0FBSyxFQUFFQyxzQkFBVUQsS0FkSjs7RUFnQmI7Ozs7O0VBS0FFLFFBQVEsRUFBRUQsc0JBQVVDLFFBckJQOztFQXVCYjs7Ozs7RUFLQUMsV0FBVyxFQUFFLGFBNUJBOztFQThCYjs7Ozs7O0VBTUFDLFdBQVcsRUFBRSxhQXBDQTtFQXNDYkMsV0FBVyxFQUFFLGFBdENBO0VBdUNiQyxTQUFTLEVBQUUsV0F2Q0U7RUF3Q2JDLFdBQVcsRUFBRSxhQXhDQTtFQXlDYkMsVUFBVSxFQUFFLFlBekNDO0VBMENiQyxZQUFZLEVBQUUsY0ExQ0Q7RUEyQ2JDLFlBQVksRUFBRSxjQTNDRDtFQTRDYkMsYUFBYSxFQUFFO0FBNUNGLEM7QUErQ2YiLCJuYW1lcyI6WyJTSU5HTEVDTElDSyIsIkNMSUNLIiwiRXZlbnRUeXBlIiwiREJMQ0xJQ0siLCJQT0lOVEVSRFJBRyIsIlBPSU5URVJNT1ZFIiwiUE9JTlRFUkRPV04iLCJQT0lOVEVSVVAiLCJQT0lOVEVST1ZFUiIsIlBPSU5URVJPVVQiLCJQT0lOVEVSRU5URVIiLCJQT0lOVEVSTEVBVkUiLCJQT0lOVEVSQ0FOQ0VMIl0sInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInNyYy9NYXBCcm93c2VyRXZlbnRUeXBlLmpzIl0sInNvdXJjZXNDb250ZW50IjpbbnVsbF19